export function getMenuId(path, list) {
  let res = {
    state: false,
    i_id: "",
  };
  list.map((one) => {
    if (one.vc_url === path) {
      res = {
        state: true,
        i_id: one.i_id,
		
      };
    }
    if (one.smenuList && one.smenuList.length > 0) {
      let result = getMenuId(path, one.smenuList);
      res = result.state ? result : res;
    }
  });
  return res;

}